import { PractitionerNote } from '@repo/types';
import { useQuery } from '@tanstack/react-query';
import { API } from 'api';

import { apiBasePath, apiName } from 'assets/constants';
import { PUBLISHED_PRACTITIONER_NOTE_QUERY_KEY } from './constants';

const getPublishedPractitionerNote = async (
  kitId: string,
): Promise<PractitionerNote | null> => {
  if (!kitId) return null;

  const response = await API.get(
    apiName,
    `${apiBasePath}/kits/${kitId}/practitioner-note`,
    {},
  );

  return response ?? null;
};

// Here we have the note for the consumer user (published only)
export function usePublishedPractitionerNote(kitId: string | null) {
  return useQuery({
    queryKey: [PUBLISHED_PRACTITIONER_NOTE_QUERY_KEY, kitId],
    queryFn: () => getPublishedPractitionerNote(kitId!),
    enabled: !!kitId,
  });
}
